module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-Purse-72dpi.342717b2.jpg";